import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useRecoilValue } from "recoil";
import { setTokenSourceMapRange } from "typescript";
import { walletState } from "../../context/walletState";
import { useLiquidity } from "../../hooks/useLiquidity";
import { useConnectWallet } from "../../hooks/useTxnClient";
import PercentInput from "../common/input/PercentInput";
import LoadingModal from "../common/loading-modal/LoadingModal";
import SwapHeaderMenu from "../swap/SwapHeaderMenu";
import CustomLinkToast from "./CustomLinkToast";
import GetLpViewing from "./GetLpViewing";
import PulseLoader from "react-spinners/PulseLoader";

const UnBonding = ({isLpLoading1, userLiq1, getUserAmt, setIsModalOpen, getUserBondAmt}: any) => {
  const location = useLocation();
  const { pairs, token1, token2 } = location.state;
  const [userBond, setUserBond] = useState<any>("");
  const [lpToBeUnbond, setLpToBeUnbond] = useState<any>("");
  const [inputVal, setInputVal] = useState("");
  const { doUnbondLiquidity, getPoolUserBonded, getPoolUserAmount } =
    useLiquidity();

  const { address } = useRecoilValue(walletState);
  const connectWallet = useConnectWallet();
  const [lpbal, setLpBal] = useState<any>("0.00");
  const [isLpLoading, setIsLpLoading] = useState(false);

  const navigate = useNavigate();

  const getLP = async () => {
    setIsLpLoading(true);
    const { userLpBonded } = await getPoolUserBonded(pairs.pair_name);
    setUserBond(userLpBonded);
    const { lpBalance } = await getPoolUserAmount(pairs.pair_name);
    setLpBal(lpBalance);
    setIsLpLoading(false);
  };

  const [isLoading, setIsLoading] = useState(false);
  const handleUnbond = async () => {
    // doUnbonding
    setIsLoading(true);
    const unbondRes = await doUnbondLiquidity(pairs.pair_name, lpToBeUnbond);

    setIsLoading(false);
    // only for testnet
    const txnHash = unbondRes.transactionHash ? unbondRes.transactionHash : "";
    toast.info(<CustomLinkToast hash={txnHash} />);
    // navigate(-1);
    getUserAmt();
    getUserBondAmt();
    setIsModalOpen(false);
  };

  useEffect(() => {
    getLP();
  }, []);

  useEffect(() => {
    if (inputVal !== "") {
      setLpToBeUnbond(((Number(userBond) * Number(inputVal)) / 100).toFixed(2));
    }
  }, [inputVal, setLpBal]);

  const handleMax = () => {
    setLpToBeUnbond(userBond);
    setInputVal("100");
  };

  const handlelpViewing = () => {
    getLP();
  };

  return (
    <div className="addliquidity-wrapper">
      <div className="remove-liquidity">
        <p>{pairs.pair_name}-LP</p>
        <span>
          {isLpLoading1 ? (
            <PulseLoader
              color="#1790FF"
              loading={true}
              // cssOverride={override}
              size={10}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          // ) : (!Number(lpbal) && Number(lpbal) === 0) || Number(lpbal) ? (
          ) : (!Number(userLiq1) && Number(userLiq1) === 0) || Number(userLiq1) ? (
            //  ((Number(userBond) * Number(inputVal)) / 100).toFixed(4)
            <input
              className="manual-liquidity-input"
              type="number"
              value={lpToBeUnbond}
              onChange={(e) => {
                setLpToBeUnbond(e.target.value);
              }}
              placeholder="0.00"
              autoFocus={true}
            />
          ) : (
            <GetLpViewing
              pair={pairs.pair_name}
              handlelpViewing={handlelpViewing}
            />
          )}
        </span>
        <div className="remove-liquidity-token">
          <div className="token1_input max_bonding">
            <div className="icc-balance-wrapper">
              Available{" "}
              {isLpLoading
                ? "-"
                : (!Number(lpbal) && Number(lpbal) === 0) || Number(lpbal)
                ? Number(userBond).toFixed(4)
                : "-"}
            </div>
            <div className="max-wrapper" onClick={handleMax}>
              <p>MAX</p>
            </div>
            {/* <input className="manual-percent" type="number" value={input1} onChange={handleinput1}/> */}
          </div>
        </div>

        <div className="slider">
          <input
            type="range"
            min="0"
            max="100"
            value={inputVal ? inputVal : 0}
            onChange={(e) => setInputVal(e.target.value)}
          />
          <p>{inputVal}%</p>
        </div>
        <div className="icc-percent-input-wrapper liquidity-percent">
          <PercentInput
            bal={"25"}
            inputVal={(inputVal: string) => setInputVal(inputVal)}
          />
        </div>
      </div>
      <div
        className={`pool-holding-button liquidity-btn ${
          !address
            ? ""
            : !Number(userBond) ||
              !Number(lpToBeUnbond) ||
              Number(lpToBeUnbond) === 0 ||
              Number(lpToBeUnbond) > Number(userBond)
            ? "disabled-button"
            : ""
        }`}
        onClick={
          address
            ? !Number(userBond) ||
              !Number(lpToBeUnbond) ||
              Number(lpToBeUnbond) === 0 ||
              Number(lpToBeUnbond) > Number(userBond)
              ? () => {}
              : handleUnbond
            : connectWallet
        }
      >
        {address
          ? !Number(userBond)
            ? "Bond First"
            : !Number(lpToBeUnbond) || Number(lpToBeUnbond) === 0
            ? "Amount is zero"
            : Number(lpToBeUnbond) > Number(userBond)
            ? "Insufficient Balance"
            : "Unbond Token"
          : "Connect Wallet"}
      </div>
      <LoadingModal
        content={["UnBonding Token", `${pairs.pair_name}-LP`]}
        isOpen={isLoading}
      />
    </div>
  );
};

export default UnBonding;
